import { render } from "./FaqQuestions.vue?vue&type=template&id=4f547325&scoped=true"
import script from "./FaqQuestions.vue?vue&type=script&lang=js"
export * from "./FaqQuestions.vue?vue&type=script&lang=js"

import "./FaqQuestions.vue?vue&type=style&index=0&id=4f547325&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f547325"]])

export default __exports__